export default __webpack_public_path__ + "static/media/A14.4963478e.png";